// extracted by mini-css-extract-plugin
module.exports = {"Gallery_theme_dark":"FxcnB","item":"HRNSO","overlay":"gE6Sx","title":"oqj60","image":"_8A0uf","iconWrapper":"UilPB","icon":"bfpFR","video":"QiTbj","tours":"H49sB"};